export default "__VITE_ASSET__rGFf4FS3__"